import { useI18n } from '@muse/i18n'
import { useEffect } from 'react'

import { sendEvent } from '@core/analytics'

import { MadeWithAudacityBanner } from '../components/made-with-audacity-banner/MadeWithAudacityBanner'
import { AUDACITY_MUSEHUB_DOWNLOAD_URL, AUDACITY_SITE_URL } from '../constants/audacityBanner'

type TMadeWithAudacityBannerContainerProps = {
    audioId: string
}

export const MadeWithAudacityBannerContainer = ({
    audioId,
}: TMadeWithAudacityBannerContainerProps) => {
    const { t } = useI18n()

    useEffect(() => {
        sendEvent({ name: 'mu_button_show', payload: { audio: audioId } })
    }, [audioId])

    const handleClick = () => {
        sendEvent({ name: 'mu_button_click', payload: { audio: audioId } })
    }

    return (
        <MadeWithAudacityBanner
            label={t('i18n.audioMadeWithAudacityLabel')}
            logoAlt={t('i18n.audioMadeWithAudacityLogoAlt')}
            ctaAlt={t('i18n.audioMadeWithAudacityCta')}
            audacityHref={AUDACITY_SITE_URL}
            downloadHref={AUDACITY_MUSEHUB_DOWNLOAD_URL}
            onCtaClick={handleClick}
        />
    )
}
